/**
 * Canonical set of Tranquility-internal ("employee") email domains and the
 * matcher used to classify a signed-in user as internal vs. external.
 *
 * Single source of truth for every call site (employee/has-access,
 * EmployeeSwitcher, the session/extend heartbeat) so the domain list can't
 * drift between copies when it changes.
 */
export const TAI_DOMAINS = new Set([
  "tranquility.ai",
  "tranquility-ai.net",
  "tranquility-ai.com",
]);

export function isTaiEmail(email: string | undefined): boolean {
  if (!email) return false;
  const [, domain] = email.split("@");
  return !!domain && TAI_DOMAINS.has(domain.toLowerCase());
}
